import asLazyPage from 'hocs/asLazyPage';
import { IS_PROD } from 'utils/localFlags';

export const devRoutes: RoutesConfig = !IS_PROD
  ? [
      {
        path: '/dev',
        component: asLazyPage(() => import('pages/dev')),
        exact: true,
      },
      {
        path: '/dev/form',
        component: asLazyPage(
          () => import('components/molecules/reactHookForm/page')
        ),
        exact: true,
      },
      {
        path: '/dev/form/v2',
        component: asLazyPage(() => import('components/molecules/form/page')),
        exact: true,
      },
      {
        path: '/dev/flags',
        component: asLazyPage(() => import('pages/devFlags')),
        exact: true,
      },
      {
        path: '/dev/draggable',
        component: asLazyPage(
          () => import('components/molecules/draggable-droppable/page')
        ),
        exact: true,
      },
      {
        path: '/dev/memoization',
        component: asLazyPage(() => import('pages/devMemo')),
        exact: true,
      },
    ]
  : [];
